import { FunctionComponent } from 'react'
import Blink from '@components/Blink'
import styled, { css } from 'styled-components'
import { CreditProps } from '@widgets/ArticleTextbox/types'

const StyledCredit = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_70 },
      },
    },
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 14px;
    line-height: 1.4;
    font-weight: normal;
    color: ${grey_70};
    text-transform: uppercase;
  `}
`

const StyledBlink = styled(Blink)`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        brandColors: { brand_55 },
        grey: { grey_70 },
      },
    },
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 14px;
    line-height: 1.4;
    font-weight: normal;
    color: ${grey_70};
    text-transform: uppercase;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: ${brand_55};
    }
  `}
`

const Credit: FunctionComponent<CreditProps> = ({ blinkProps, children }) => {
  if (blinkProps?.href) {
    return <StyledBlink {...blinkProps}>{children}</StyledBlink>
  }

  return <StyledCredit>{children}</StyledCredit>
}

export default Credit
